import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "counter", "prevButton", "nextButton"]
  static values = { galleryId: String, currentIndex: { type: Number, default: 0 } }

  open({ params: { index } }) {
    this.currentIndexValue = index
    document.dispatchEvent(new CustomEvent("ui:dialog:open", { detail: { id: this.galleryIdValue } }))
  }

  prev() {
    if (this.currentIndexValue > 0) {
      this.currentIndexValue--
    }
  }

  next() {
    if (this.currentIndexValue < this.slideTargets.length - 1) {
      this.currentIndexValue++
    }
  }

  currentIndexValueChanged(value) {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== value)
    })

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${value + 1} / ${this.slideTargets.length}`
    }

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = value === 0
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = value === this.slideTargets.length - 1
    }
  }
}
